<template>
    <div class="w-100">
        <div class="structure drop-zone" v-if="value">
            <button data-bs-toggle="modal" data-bs-target="#rawJson">{{ $t("editPanel.json") }}</button>
            <Blocks v-model="value.pages[selectedPage]" :tabs="0" :up="true"/>
        </div>
        <div class="text-center edit_panel">
            <h1>{{ $t("editPanel.heading") }}</h1>
            <div>
                <p>{{ $t("editPanel.component") }}</p>
                <p>{{ settings.component }}</p>
            </div>
            <div>
                <p>{{ $t("editPanel.id") }}</p>
                <p v-if="disabled">{{ $t("editPanel.notSelected") }}</p>
                <textarea  v-else v-model="settings.id" class="w-100" :disabled="disabled" />
            </div>
            <div>
                <p>{{ $t("editPanel.class") }}</p>
                <textarea v-model="settings.class" class="w-100" :disabled="disabled" />
            </div>
            <div>
                <p>{{ $t("editPanel.style") }}</p>
                <textarea v-model="settings.style" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Input'">
                <p>{{ $t("editPanel.type") }}</p>
                <select v-model="settings.type" class="form-select" :disabled="disabled">
                    <option value="text">{{ $t("editPanel.input.text") }}</option>
                    <option value="number">{{ $t("editPanel.input.number") }}</option>
                    <option value="date">{{ $t("editPanel.input.date") }}</option>
                    <option value="checkbox">{{ $t("editPanel.input.checkbox") }}</option>
                    <option value="datetime-local">{{ $t("editPanel.input.datetime") }}</option>
                </select>
            </div>
            <div>
                <p>{{ $t("editPanel.calculate") }}</p>
                <textarea v-model="settings.calculate" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Image'">
                <p>{{ $t("editPanel.src") }}</p>
                <textarea v-model="settings.src" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Link'">
                <p>{{ $t("editPanel.href") }}</p>
                <textarea v-model="settings.href" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Link'">
                <p>{{ $t("editPanel.target") }}</p>
                <textarea v-model="settings.target" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Switch' || settings.component == 'Select' || settings.component == 'Input' || settings.component == 'Multiselect'">
                <p>{{ $t("editPanel.value") }}</p>
                <textarea v-model="settings.value" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Select' || settings.component == 'Input'">
                <p>{{ $t("editPanel.placeholder") }}</p>
                <textarea v-model="settings.placeholder" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Input'">
                <p>{{ $t("editPanel.min") }}</p>
                <input type="number" v-model="settings.min" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Input'">
                <p>{{ $t("editPanel.max") }}</p>
                <input type="number" v-model="settings.max" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Switch' || settings.component == 'Multiselect' || settings.component == 'Select'">
                <p>{{ $t("editPanel.options") }}</p>
                <textarea v-model="settings.options" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Multiselect' || settings.component == 'Input'">
                <p>{{ $t("editPanel.placeholder") }}</p>
                <textarea v-model="settings.placeholder" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Multiselect'">
                <p>{{ $t("editPanel.multiple") }}</p>
                <input type="checkbox" v-model="settings.multiple" class="w-100 form-check-input" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'Block'">
                <p>{{ $t("editPanel.targetId") }}</p>
                <textarea v-model="settings.target_id" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'ProductRow' ">
                <p>{{ $t("editPanel.productId") }}</p>
                <textarea v-model="settings.product_id" class="w-100" :disabled="disabled" />
            </div>
            <div v-if="settings.component == 'ProductRow' ">
                <p>{{ $t("editPanel.productCountCalculate") }}</p>
                <textarea v-model="settings.product_count_calculate" class="w-100" :disabled="disabled" />
            </div>
            <div>
                <p>{{ $t("editPanel.text") }}</p>
                <textarea v-model="settings.text" class="w-100" :disabled="disabled" />
            </div>
            <div>
                <p>{{ $t("editPanel.format") }}</p>
                <input type="checkbox" v-model="settings.format" class="w-100 form-check-input" :disabled="disabled" />
            </div>
            <div>
                <p>{{ $t("editPanel.units") }}</p>
                <textarea v-model="settings.units" class="w-100" :disabled="disabled" />
            </div>
            <div>
                <p>{{ $t("editPanel.hide") }}</p>
                <textarea v-model="settings.hide" class="w-100" :disabled="disabled" />
            </div>
            <div>
                <p>{{ $t("editPanel.disabled") }}</p>
                <textarea v-model="settings.disabled" class="w-100" :disabled="disabled" />
            </div>
        </div>
    </div>
    <Popup :header="$t('editPanel.json')" :editable="true" id="rawJson" :xl="true">
      <template v-slot:editor>
        <div class="jsonEditor">
            <JsonEditorVue v-model="popupValue"/>
        </div>
      </template>
    </Popup>
</template>

<script>
import Blocks from '@/components/calculations/Blocks.vue';
import Popup from '@/components/Popup.vue';
import JsonEditorVue from 'json-editor-vue'

export default {
    props: {
        modelValue: {},
        selectedPage: {
            type: Number,
            default: 0
        }
    },
    emits: ['update:modelValue'],
    components: {
        Blocks,
        Popup,
        JsonEditorVue
    },
    data: function () {
        return {
            start: true,
            settings: {
                id: null,
                class: null,
                style: null,
                type: null,
                calculate: null,
                units: null,
                hide: null,
                disabled: null,
                text: null
            }
        }
    },
    computed: {
        disabled: function () {
            return this.start
        },
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        popupValue: {
            get() {
                return this.value
            },
            set(value) {
                console.log(value);
                this.value = value
            }
        },
    },
    watch: {
        "$store.getters.componentData": function (value) {
            this.settings = this.$store.getters.componentData;
            this.start = false;
        },
        settings: {
            handler: function(value){
                this.$store.getters.componentUpdate(value);
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="scss">
.edit_panel {
    background-color: bisque;
    border-right: 1px solid grey;
    padding: 0px 10px;
    position: fixed;
    overflow-y: scroll;
    height: calc(100vh - 68px);
    width: 12%;
    left: 20%;
}
.structure {
    color: white;
    background-color: grey;
    padding: 10px;
    position: fixed;
    overflow-y: scroll;
    height: calc(100vh - 68px);
    width: 20%;
    left: 0px;
}
.jsonEditor {
    width: 1000px;
    height: 80vh;
    textarea {
        width: 100%;
        height: 100%;
    }
}
</style>
